import * as yup from 'yup';
import statsCardGreyIcon from 'assets/images/icons/stats-card-grey.svg';
import textBlockGreyIcon from 'assets/images/icons/text-block-grey.svg';
import imageIcon from 'assets/images/icons/image.svg';
import panelIcon from 'assets/images/icons/panel.svg';
import barChartHorizontalGreyIcon from 'assets/images/icons/bar-chart-horizontal-grey.svg';
import barChartVerticalGreyIcon from 'assets/images/icons/bar-chart-vertical-grey.svg';
import stackedBarChartHorizontalGreyIcon from 'assets/images/icons/stacked-bar-chart-horizontal-grey.svg';
import stackedBarChartVerticalGreyIcon from 'assets/images/icons/stacked-bar-chart-vertical-grey.svg';
import pieChartGreyIcon from 'assets/images/icons/pie-chart-grey.svg';
import speedometerGreyIcon from 'assets/images/icons/speedometer-grey.svg';
import doughnutChartGreyIcon from 'assets/images/icons/doughnut-chart-grey.svg';
import lineGraphGreyIcon from 'assets/images/icons/line-graph-grey.svg';
import heatMapTableGreyIcon from 'assets/images/icons/heatmap-table-grey.svg';

export const internalDashboardTabs = [
  {
    id: 1,
    title: 'sidebar_internal_dashboard',
    isSelected: true,
    titleIcon: '',
    breadcrumbValue: {
      icon: panelIcon,
      items: ['sidebar_internal_dashboard', 'sidebar_internal_dashboard'],
    },
  },
];

export const AddDashboardSchema = yup.object({
  dashboardTitle: yup.string().required(),
});

export const AddPageSchema = yup.object({
  pageTitle: yup.string().required(),
});

export const DEFAULT_NUMBER_OF_COLUMNS = 12;
export const DEFAULT_NUMBER_OF_ROWS = 15;
export const WIDGET_LOAD_CHUNK_SIZE = 5;

export const newWidgetTabList = [
  {
    id: 1,
    title: 'tabs_basic',
    value: 'basic',
  },
  {
    id: 2,
    title: 'tabs_advance',
    value: 'advance',
  },
];

export const WIDGET_TYPES = Object.freeze({
  STATS_CARD: 'statsCard',
  TEXT_CARD: 'textCard',
  IMAGE_CARD: 'imageCard',
  BAR_CHART_HORIZONTAL: 'barChartHorizontal',
  BAR_CHART_VERTICAL: 'barChartVertical',
  STACKED_BAR_CHART_HORIZONTAL: 'stackedBarChartHorizontal',
  STACKED_BAR_CHART_VERTICAL: 'stackedBarChartVertical',
  PIE_CHART: 'pieChart',
  DIAL_CHART: 'dialChart',
  DOUGHNUT_CHART: 'doughnutChart',
  LINE_CHART: 'lineChart',
  HEATMAP_TABLE: 'heatMapTable',
});

export const WIDGET_CONFIG = Object.freeze({
  [WIDGET_TYPES.STATS_CARD]: {
    basicProps: {
      chartType: WIDGET_TYPES.STATS_CARD,
      calculation: '',
      negativeScorePercentage: 100,
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '14px',
      captionFontWeight: 'medium',
      formatting: 'default',
      formattingFontSize: '36px',
      formattingFontWeight: 'semiBold',
      formattingRanges: [],
    },
  },
  [WIDGET_TYPES.TEXT_CARD]: {
    basicProps: {
      chartType: WIDGET_TYPES.TEXT_CARD,
      caption: '',
      textLinks: [],
    },
    advancedProps: {
      tooltip: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '20px',
      captionFontWeight: 'semiBold',
      fontSize: '14px',
      fontWeight: 'semiBold',
    },
  },
  [WIDGET_TYPES.IMAGE_CARD]: {
    basicProps: {
      chartType: WIDGET_TYPES.IMAGE_CARD,
      widgetImage: {},
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
    },
  },
  [WIDGET_TYPES.BAR_CHART_HORIZONTAL]: {
    basicProps: {
      chartType: WIDGET_TYPES.BAR_CHART_HORIZONTAL,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[]],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formatting: 'default',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
      formattingRanges: [],
    },
  },
  [WIDGET_TYPES.BAR_CHART_VERTICAL]: {
    basicProps: {
      chartType: WIDGET_TYPES.BAR_CHART_VERTICAL,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[]],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formatting: 'default',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
      formattingRanges: [],
    },
  },
  [WIDGET_TYPES.STACKED_BAR_CHART_HORIZONTAL]: {
    basicProps: {
      chartType: WIDGET_TYPES.STACKED_BAR_CHART_HORIZONTAL,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[], []],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formatting: 'default',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
      formattingRanges: [],
    },
  },
  [WIDGET_TYPES.STACKED_BAR_CHART_VERTICAL]: {
    basicProps: {
      chartType: WIDGET_TYPES.STACKED_BAR_CHART_VERTICAL,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[], []],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formatting: 'default',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
      formattingRanges: [],
    },
  },
  [WIDGET_TYPES.PIE_CHART]: {
    basicProps: {
      chartType: WIDGET_TYPES.PIE_CHART,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[]],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
    },
  },
  [WIDGET_TYPES.DIAL_CHART]: {
    basicProps: {
      chartType: WIDGET_TYPES.DIAL_CHART,
      calculation: '',
      negativeScorePercentage: 100,
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
    },
  },
  [WIDGET_TYPES.DOUGHNUT_CHART]: {
    basicProps: {
      chartType: WIDGET_TYPES.DOUGHNUT_CHART,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[]],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formattingDisplayOption: 'percentage',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
    },
  },
  [WIDGET_TYPES.LINE_CHART]: {
    basicProps: {
      chartType: WIDGET_TYPES.LINE_CHART,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[]],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
    },
  },
  [WIDGET_TYPES.HEATMAP_TABLE]: {
    basicProps: {
      chartType: WIDGET_TYPES.HEATMAP_TABLE,
      calculation: '',
      negativeScorePercentage: 100,
      dimensions: [[], []],
      label: '',
      caption: '',
    },
    advancedProps: {
      tooltip: '',
      // filters: [],
      linkedPageId: '',
      linkedDashboardId: '',
      backgroundColor: '#ffffff',
      textColor: '#000000',
      captionFontSize: '24px',
      captionFontWeight: 'semiBold',
      formatting: 'default',
      formattingFontSize: '12px',
      formattingFontWeight: 'regular',
      formattingRanges: [],
    },
  },
});

export const WIDGET_DEFAULT_SIZE = {
  [WIDGET_TYPES.STATS_CARD]: { takeRows: 2, takeColumns: 2 },
  [WIDGET_TYPES.TEXT_CARD]: { takeRows: 2, takeColumns: 2 },
  [WIDGET_TYPES.IMAGE_CARD]: { takeRows: 2, takeColumns: 2 },
  [WIDGET_TYPES.BAR_CHART_HORIZONTAL]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.BAR_CHART_VERTICAL]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.STACKED_BAR_CHART_HORIZONTAL]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.STACKED_BAR_CHART_VERTICAL]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.PIE_CHART]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.DIAL_CHART]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.DOUGHNUT_CHART]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.LINE_CHART]: { takeRows: 4, takeColumns: 6 },
  [WIDGET_TYPES.HEATMAP_TABLE]: { takeRows: 4, takeColumns: 6 },
};

export const chartTypeOptions = {
  children: [
    {
      value: WIDGET_TYPES.STATS_CARD,
      displayValue: 'select_stats_card',
      icon: statsCardGreyIcon,
    },
    {
      value: WIDGET_TYPES.TEXT_CARD,
      displayValue: 'select_text_card',
      icon: textBlockGreyIcon,
    },
    {
      value: WIDGET_TYPES.IMAGE_CARD,
      displayValue: 'select_image_card',
      icon: imageIcon,
    },
    {
      value: WIDGET_TYPES.BAR_CHART_HORIZONTAL,
      displayValue: 'select_bar_chart_horizontal',
      icon: barChartHorizontalGreyIcon,
    },
    {
      value: WIDGET_TYPES.BAR_CHART_VERTICAL,
      displayValue: 'select_bar_chart_vertical',
      icon: barChartVerticalGreyIcon,
    },
    {
      value: WIDGET_TYPES.STACKED_BAR_CHART_HORIZONTAL,
      displayValue: 'select_stacked_bar_chart_horizontal',
      icon: stackedBarChartHorizontalGreyIcon,
    },
    {
      value: WIDGET_TYPES.STACKED_BAR_CHART_VERTICAL,
      displayValue: 'select_stacked_bar_chart_vertical',
      icon: stackedBarChartVerticalGreyIcon,
    },
    {
      value: WIDGET_TYPES.PIE_CHART,
      displayValue: 'select_pie_chart',
      icon: pieChartGreyIcon,
    },
    {
      value: WIDGET_TYPES.DIAL_CHART,
      displayValue: 'select_dial_chart',
      icon: speedometerGreyIcon,
    },
    {
      value: WIDGET_TYPES.DOUGHNUT_CHART,
      displayValue: 'select_doughnut_chart',
      icon: doughnutChartGreyIcon,
    },
    {
      value: WIDGET_TYPES.LINE_CHART,
      displayValue: 'select_line_chart',
      icon: lineGraphGreyIcon,
    },
    {
      value: WIDGET_TYPES.HEATMAP_TABLE,
      displayValue: 'select_heatmap_table',
      icon: heatMapTableGreyIcon,
    },
  ],
};

export const calculationsOptions = {
  children: [
    {
      value: 'formsCount',
      displayValue: 'select_forms_count',
    },
    {
      value: 'submissionsCount',
      displayValue: 'select_submissions_count',
    },
    {
      value: 'submissionsAverageScore',
      displayValue: 'select_submissions_avg_score',
    },
    {
      value: 'negativeAverageScore',
      displayValue: 'select_avg_score_less_than_100',
    },
    {
      value: 'usersCount',
      displayValue: 'select_users_count',
    },
  ],
};

export const dashboardFontWeightOptions = {
  children: [
    {
      value: 'regular',
      displayValue: 'Regular',
    },
    {
      value: 'medium',
      displayValue: 'Medium',
    },
    {
      value: 'semiBold',
      displayValue: 'Semibold',
    },
    {
      value: 'bold',
      displayValue: 'Bold',
    },
  ],
};

export const dashboardFormattingDisplayOptionsList = {
  children: [
    {
      value: 'percentage',
      displayValue: 'Percentage',
    },
    {
      value: 'number',
      displayValue: 'Number',
    },
    {
      value: 'both',
      displayValue: 'Number & Percentage - #%',
    },
  ],
};

export const dashboardFontSizeOptions = {
  children: Array.from({ length: 35 }, (_, i) => {
    const size = i + 10;
    return {
      value: `${size}px`,
      displayValue: `${size}px`,
    };
  }),
};

export const staticDimensionsOptions = [
  {
    value: 'topic',
    displayValue: 'select_topics',
  },
  {
    value: 'completedDate',
    displayValue: 'select_date_by_days',
  },
  {
    value: 'userName',
    displayValue: 'select_users',
  },
  {
    value: 'reportState',
    displayValue: 'select_report_states',
  },
];

export const DashboardTableFields = [
  {
    name: 'dashboardtitle',
    displayName: 'table_header_dashboard_name',
    type: 'string',
    mandatory: true,
    isRequired: true,
    isSelected: true,
    associatedKey: 'dashboardTitle',
  },
  {
    name: 'lname',
    displayName: 'table_header_dashboard_pages',
    type: 'string',
    isRequired: true,
    mandatory: true,
    isSelected: true,
    associatedKey: 'pages',
    populateFunc: 'countDashboardPages',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitials',
  },
  {
    name: 'createdAt',
    displayName: 'text_last_created_on',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdAt',
    populateFunc: 'populateDate',
  },
  {
    name: 'allowedProfiles',
    displayName: 'text_dashboard_access',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'allowedProfiles',
    populateFunc: 'populateAllowedProfiles',
  },
  {
    name: 'addPage',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateAddDashboardPage',
    callbackFunc: 'openAddPageModal',
  },
];

export const DashboardListPagesTableFields = [
  {
    name: 'pageTitle',
    displayName: 'table_header_dashboard_page_name',
    type: 'string',
    mandatory: true,
    isRequired: true,
    isSelected: true,
    associatedKey: 'pageTitle',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitials',
  },
  {
    name: 'createdAt',
    displayName: 'text_last_created_on',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdAt',
    populateFunc: 'populateDate',
  },
  {
    name: 'allowedProfiles',
    displayName: 'text_dashboard_access',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'allowedProfiles',
    populateFunc: 'populateAllowedProfiles',
  },
  {
    name: 'viewDashboard',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateGoToDashboardPage',
    callbackFunc: 'goToDashboardPage',
  },
];

export const DashboardDetailPagesTableFields = [
  {
    name: 'pageTitle',
    displayName: 'table_header_dashboard_page_name',
    type: 'string',
    mandatory: true,
    isRequired: true,
    isSelected: true,
    associatedKey: 'pageTitle',
  },
  {
    name: 'createdBy',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdBy',
    populateFunc: 'populateUserNameWithInitials',
  },
  {
    name: 'createdAt',
    displayName: 'text_last_created_on',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'createdAt',
    populateFunc: 'populateDate',
  },
  {
    name: 'allowedProfiles',
    displayName: 'text_dashboard_access',
    type: 'string',
    isRequired: true,
    isSelected: true,
    associatedKey: 'allowedProfiles',
    populateFunc: 'populateAllowedProfiles',
  },
  {
    name: 'editAdminProfiles',
    displayName: '',
    type: 'string',
    isRequired: true,
    isSelected: true,
    populateFunc: 'populateEditAdminProfilesDropdown',
    callbackFunc: 'getAndUpdatedAdminProfiles',
  },
];

export const dashboardWidgetThemeColors = [
  '#FFFFFF',
  '#2A2B28',
  '#3DD3B0',
  '#E56171',
  '#01BEDE',
  '#EECB31',
  '#C296E5',
  '#6C7A89',
];

export function getDefaultValues(chartType) {
  if (!chartType) {
    return { basicProps: {}, advancedProps: {} };
  }

  const config = WIDGET_CONFIG[chartType];

  const extractDefaults = (section) => {
    const result = {};
    for (const key in section) {
      const value = section[key];
      result[key] = value;
    }
    return result;
  };
  return {
    advancedProps: extractDefaults(config.advancedProps),
    basicProps: extractDefaults(config.basicProps),
  };
}

export const mapApiDimensionsToUi = (dimensions = []) =>
  dimensions.map((dim) =>
    dim.optionDetails ? dim.optionDetails.selectedOption.map((opt) => opt.value) : [dim.type],
  );

export const buildDimensionsPayload = (dimensions, lookup, staticTypes) =>
  dimensions.map((dim) => {
    let type;
    const selectedOption = [];

    dim.forEach((v) => {
      const meta = lookup[v];
      type = meta.type;
      if (!staticTypes.includes(type)) {
        selectedOption.push({ key: meta.key, value: v });
      }
    });

    return {
      type,
      ...(selectedOption.length && {
        optionDetails: { parentId: null, selectedOption },
      }),
    };
  });

export const getMaxTakenRows = (widgetList) => {
  let maxTakenRows = 0;
  widgetList.forEach((widget) => {
    const endRow = widget.startRow + widget.takeRows - 1;
    maxTakenRows = Math.max(maxTakenRows, endRow);
  });
  return maxTakenRows;
};

export const findAvailablePosition = (
  existingWidgets,
  widgetSize,
  totalRows = DEFAULT_NUMBER_OF_ROWS,
  totalColumns = DEFAULT_NUMBER_OF_COLUMNS,
) => {
  const widgetRows = widgetSize.takeRows;
  const widgetColumns = widgetSize.takeColumns;
  // 1️⃣ Create empty grid
  const grid = Array.from({ length: totalRows }, () => Array(totalColumns).fill(false));

  // 2️⃣ Mark occupied cells
  for (const widget of existingWidgets) {
    for (let r = widget.startRow - 1; r < widget.startRow - 1 + widget.takeRows; r++) {
      for (let c = widget.startColumn - 1; c < widget.startColumn - 1 + widget.takeColumns; c++) {
        if (grid[r] && grid[r][c] !== undefined) {
          grid[r][c] = true;
        }
      }
    }
  }

  // 3️⃣ Scan for available space
  for (let row = 0; row <= totalRows - widgetRows; row++) {
    for (let col = 0; col <= totalColumns - widgetColumns; col++) {
      let fits = true;

      for (let r = 0; r < widgetRows && fits; r++) {
        for (let c = 0; c < widgetColumns; c++) {
          if (grid[row + r][col + c]) {
            fits = false;
            break;
          }
        }
      }

      if (fits) {
        return {
          startRow: row + 1,
          startColumn: col + 1,
          takeRows: widgetRows,
          takeColumns: widgetColumns,
        };
      }
    }
  }

  // 4️⃣ No space available
  return null;
};

export const chartTempData = {
  [WIDGET_TYPES.STATS_CARD]: { count: 1000 },
  [WIDGET_TYPES.TEXT_CARD]: null,
  [WIDGET_TYPES.IMAGE_CARD]: null,
  [WIDGET_TYPES.BAR_CHART_HORIZONTAL]: [
    { xaxis: '2026-01-14', value: 0.5 },
    { xaxis: '2026-01-19', value: 2 },
    { xaxis: '2026-01-20', value: 4 },
  ],
  [WIDGET_TYPES.BAR_CHART_VERTICAL]: [
    { xaxis: '2026-01-14', value: 0.5 },
    { xaxis: '2026-01-19', value: 2 },
    { xaxis: '2026-01-20', value: 4 },
  ],
  [WIDGET_TYPES.STACKED_BAR_CHART_HORIZONTAL]: [
    { xaxis: '2026-01-14', yaxis: 'Set 1', value: 0.5 },
    { xaxis: '2026-01-19', yaxis: 'Set 1', value: 2 },
    { xaxis: '2026-01-20', yaxis: 'Set 1', value: 4 },
    { xaxis: '2026-01-20', yaxis: 'Set 2', value: 7 },
  ],
  [WIDGET_TYPES.STACKED_BAR_CHART_VERTICAL]: [
    { xaxis: '2026-01-14', yaxis: 'Set 1', value: 0.5 },
    { xaxis: '2026-01-19', yaxis: 'Set 1', value: 2 },
    { xaxis: '2026-01-20', yaxis: 'Set 1', value: 4 },
    { xaxis: '2026-01-20', yaxis: 'Set 2', value: 4 },
  ],
  [WIDGET_TYPES.PIE_CHART]: [
    { xaxis: 'Form 1', value: 2 },
    { xaxis: 'Form 2', value: 5 },
  ],
  [WIDGET_TYPES.DIAL_CHART]: { count: 60 },
  [WIDGET_TYPES.DOUGHNUT_CHART]: [
    { xaxis: 'Set 1', value: 1 },
    { xaxis: 'Set 2', value: 2 },
  ],
  [WIDGET_TYPES.LINE_CHART]: [
    { xaxis: 'Set 1', value: 12 },
    { xaxis: 'Set 1', value: 19 },
    { xaxis: 'Set 1', value: 15 },
  ],
  [WIDGET_TYPES.HEATMAP_TABLE]: [
    { xaxis: '2026-01-14', yaxis: 'Set 1', value: 0.5 },
    { xaxis: '2026-01-19', yaxis: 'Set 1', value: 2 },
    { xaxis: '2026-01-20', yaxis: 'Set 1', value: 4 },
    { xaxis: '2026-01-20', yaxis: 'Set 2', value: 7 },
  ],
};

export const FONT_FAMILY_MAP = {
  regular: 'Inter Regular',
  medium: 'Inter Medium',
  semiBold: 'Inter Semi Medium',
  bold: 'Inter Bold',
};

export const BAR_COLORS = ['#82ca9d', '#823a9d', '#8884d8'];

export const resolveConditionalColor = (value, advancedProps, defaultColor = '#000000') => {
  if (advancedProps?.formatting !== 'conditional') return defaultColor;

  const range = advancedProps.formattingRanges?.find(
    ({ from, to }) => value >= Number(from) && value <= Number(to),
  );

  return range?.color || defaultColor;
};
